import Vue from "vue"

const path = "team"

export default {
    getTeams() {
        return Vue.prototype.$http.post(`/oss/team-list`)
    },
    getTeamsJson(params) {
        return Vue.prototype.$http.post(`/${path}/teams-json`, params)
    }
}
